module.exports = __webpack_public_path__ + "static/code-5115e18a0ff66885072dbc0fc9199ac9.jpg";